import styled, { css } from 'styled-components'

export const DigitalRetailingCheckboxContentsContainer = styled.label<{ disabled?: boolean }>`
    ${({ disabled, theme }) => css`
        cursor: ${disabled ? 'not-allowed' : 'default'};
        path {
            fill: ${disabled ? theme.color.text.disabled : ''};
        }
        & span {
            color: ${disabled ? theme.color.text.disabled : ''};
        }
    `}
    display: flex;
    justify-content: space-between;
    width: 100%;

    padding: 0 0 28px 30px;

    .digital-retailing-label {
        font-size: 14px;
        font-variation-settings: 'wght' 400;
        padding-right: 8px;
    }

    .with_digital_retailing-true-simple-checkbox {
        padding: 8px 0;
    }
`
